@if (!note?.isDraft) {
  <div class="border rounded-sm" [ngClass]="{ 'bg-primary-100': isPin, 'bg-white': !isPin }">
    <!-- HEADER -->
    <div
      class="flex flex-col gap-1 h-auto pl-2 pr-2.5 border-b border-neutral-alpha-200A"
      (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between">
        @if (view !== 'COMPACT') {
          <div class="flex items-center justify-between gap-1.5">
            <div class="flex items-center gap-1.5 py-1">
              @if (isEdit) {
                <div class="px-2 pb-1">
                  <span class="font-semibold">Policy: </span>
                  <p-dropdown
                    appendTo="body"
                    [filter]="true"
                    [checkmark]="true"
                    [options]="policies"
                    optionValue="id"
                    optionLabel="number"
                    [placeholder]="'Select'"
                    [(ngModel)]="policyId"
                    styleClass="h-7 border-none !shadow-none"
                    dropdownIcon="icon-wl-arrow-drop-down"></p-dropdown>
                </div>

                <div [ngClass]="['flex items-center pl-2 pr-2.5 h-7']">
                  <span class="font-semibold">Note type: </span>
                  <app-note-status-dropdown
                    type="NOTE"
                    [totalOptions]="totalStatuses"
                    [disabled]="false"
                    [(visible)]="visible"
                    [(selected)]="statusId"
                    [initValue]="statusInit"
                    [options]="statuses"
                    [showIcon]="true"
                    [isApplyBtn]="false"
                    inputClass="h-7 border-none w-fit p-2 bg-white">
                    <ng-template let-selected="selected">
                      <div *ngIf="!selected" class="placeholder">{{ 'Type note' }}</div>
                    </ng-template>
                  </app-note-status-dropdown>
                </div>
              } @else {
                <!-- Lead -->
                <div class="w-fit flex items-center px-2 h-5 gap-1">
                  <span class="font-semibold">{{ overviewTranslatePrefix + 'lead' | translate }}: </span>
                  <a
                    [routerLink]="['/lead-management', 'lead-details', note.leadInfoRepresentation.id]"
                    class="text-green-600 hover:underline"
                    >{{ note.leadInfoRepresentation.fullName }}</a
                  >
                </div>
                <!-- Date -->
                <div class="w-fit flex items-center px-2 ml-2 h-5 gap-1">
                  <span class="font-semibold">{{ overviewTranslatePrefix + 'date' | translate }}: </span>
                  <span class="text-green-600">
                    {{ note.createdAt | date: 'EEE, MMM d, y - HH:mm' }}
                  </span>
                </div>
                <!-- Policy -->
                @if (note.policy?.number) {
                  <div class="w-fit flex items-center px-2 ml-2 h-5 gap-1">
                    <span class="font-semibold">{{ overviewTranslatePrefix + 'policy' | translate }}: </span>
                    <a
                      [routerLink]="['/lead-management', 'lead-details', note.leadInfoRepresentation.id, 'policies']"
                      [queryParams]="{ policyId: note.policy?.id }"
                      class="text-green-600 hover:underline"
                      >{{ note.policy?.number }}
                    </a>
                  </div>
                }
              }
            </div>
          </div>
        } @else {
          <!-- Policy -->
          @if (note.policy?.number && !isEdit) {
            <div class="w-fit flex items-center px-2 h-5 gap-1">
              <span class="font-semibold">{{ overviewTranslatePrefix + 'policy' | translate }}: </span>
              <a
                [routerLink]="['/lead-management', 'lead-details', note.leadInfoRepresentation.id, 'policies']"
                [queryParams]="{ policyId: note.policy?.id }"
                pTooltip="{{ note.policy?.number }}"
                class="text-green-600 hover:underline"
                [ngClass]="
                  isQuickAction
                    ? 'max-w-[100px] truncate'
                    : isLeadNoteGrid
                      ? 'max-w-[150px] truncate'
                      : isLatestNote
                        ? 'max-w-[200px] truncate'
                        : ''
                "
                >{{ note.policy?.number }}
              </a>
            </div>
          } @else if (!isEdit) {
            <!-- Note Type -->
            <div class="w-fit flex items-center px-2 gap-1">
              <span class="font-semibold">{{ overviewTranslatePrefix + 'note-type' | translate }}: </span>
              <span
                class="text-green-600"
                [ngClass]="
                  isQuickAction
                    ? 'max-w-[100px] truncate'
                    : isLeadNoteGrid
                      ? 'max-w-[150px] truncate'
                      : isLatestNote
                        ? 'max-w-[200px] truncate'
                        : ''
                "
                pTooltip="{{ note?.status?.name }}">
                {{ note?.status?.name }}
              </span>
            </div>
          }
          @if (isEdit) {
            <div class="flex flex-col py-1">
              <div class="px-2">
                <span class="font-semibold">Policy: </span>
                <p-dropdown
                  appendTo="body"
                  [filter]="true"
                  [checkmark]="true"
                  [options]="policies"
                  optionValue="id"
                  optionLabel="number"
                  [placeholder]="'Select'"
                  [(ngModel)]="policyId"
                  styleClass="h-7 border-none !shadow-none"
                  dropdownIcon="icon-wl-arrow-drop-down">
                  <ng-template let-policy pTemplate="selectedItem">
                    <div class="max-w-[175px]">
                      <div class="rounded-sm text-2 font-medium py-[2px] w-fit max-w-[150px] truncate">
                        {{ policy.number }}
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>

              <div [ngClass]="['flex items-center pl-2 pr-2.5 h-7']">
                <span class="font-semibold">Note type: </span>
                <app-note-status-dropdown
                  type="NOTE"
                  [totalOptions]="totalStatuses"
                  [disabled]="false"
                  [(visible)]="visible"
                  [(selected)]="statusId"
                  [initValue]="statusInit"
                  [options]="statuses"
                  [isLeadNoteGrid]="isLeadNoteGrid"
                  [isQuickAction]="isQuickAction"
                  [isLatestNote]="isLatestNote"
                  [showIcon]="true"
                  [isApplyBtn]="false"
                  inputClass="h-7 border-none w-fit p-2 bg-white">
                  <ng-template let-selected="selected">
                    <div *ngIf="!selected" class="placeholder">{{ 'Type note' }}</div>
                  </ng-template>
                </app-note-status-dropdown>
              </div>
            </div>
          }
        }

        <!-- ICONS -->
        <div class="flex items-center">
          @if (view !== 'COMPACT' && !isEdit) {
            <!-- By -->
            <div class="w-fit flex items-center px-2 ml-2 h-5 gap-1">
              <span class="font-semibold">{{ overviewTranslatePrefix + 'by' | translate }}: </span>
              <span class="text-green-600">
                {{ note?.createdBy?.fullName }}
              </span>
            </div>
          }
          @if ((!isEdit && view === 'COMPACT') || !isEdit) {
            <div *ngxPermissionsOnly="Permissions.NOTE_PIN">
              <div
                class="w-7 h-7 flex items-center justify-center cursor-pointer"
                (click)="onPin(); $event.stopPropagation()">
                @if (isPin) {
                  <img src="/assets/images/icons/solid-pin.svg" alt="Icon pin" />
                } @else {
                  <i class="text-4 icon-wl-pin"></i>
                }
              </div>
            </div>
            <ng-container
              *ngxPermissionsOnly="[
                Permissions.NOTE_APPEND_EDIT,
                Permissions.NOTE_APPEND_DELETE,
                Permissions.EDIT_ANY_NOTE,
                Permissions.DELETE_ANY_NOTE,
                isCreatedIn30Minutes(note.createdBy?.id, note.createdAt) ? Permissions.NOTE_ADD_APPEND : ''
              ]">
              <div
                *ngIf="userInfo.id === note.createdBy?.id || hasPermissionEditAnyNote || hasPermissionDeleteAnyNote"
                class="w-7 h-7 cursor-pointer flex items-center justify-center"
                [ngClass]="isMenu ? 'rounded-sm bg-neutral-200' : ''"
                (click)="menu.toggle($event); $event.stopPropagation()">
                <i class="icon-wl-dots-horizontal text-4 cursor-pointer"></i>
              </div>
            </ng-container>
            <p-menu appendTo="body" #menu [model]="actions" [popup]="true">
              <ng-template pTemplate="item" let-item>
                <a
                  *ngxPermissionsOnly="[
                    hasPermissionEditAnyNote ? item?.permissionEditAnyNote : null,
                    hasPermissionDeleteAnyNote ? item?.permissionDeleteAnyNote : null,
                    isCreatedByOwner(note.createdBy?.id) ? item.permission : null,
                    (item.id === 'EDIT' || item.id === 'DELETE') &&
                    isCreatedIn30Minutes(note.createdBy?.id, note.createdAt)
                      ? Permissions.NOTE_ADD_APPEND
                      : null
                  ]"
                  pRipple
                  [ngClass]="item.styleClass"
                  class="flex items-center h-9 px-2 cursor-pointer">
                  <i [class]="item.icon + ' text-6'"></i>
                  <span class="ml-2 text-3">{{ 'action.' + item.label | translate }}</span>
                </a>
              </ng-template>
            </p-menu>
          }
        </div>
      </div>
      @if ((view !== 'COMPACT' || note.policy?.number) && !isEdit) {
        <!-- Note Type -->
        <div class="w-fit flex items-center px-2 gap-1">
          <span class="font-semibold">{{ overviewTranslatePrefix + 'note-type' | translate }}: </span>
          <span
            class="text-green-600"
            [ngClass]="
              isQuickAction
                ? 'max-w-[100px] truncate'
                : isLeadNoteGrid
                  ? 'max-w-[150px] truncate'
                  : isLatestNote
                    ? 'max-w-[282px] truncate'
                    : ''
            "
            pTooltip="{{ note?.status?.name }}">
            {{ note?.status?.name }}
          </span>
        </div>
      }
    </div>

    <div class="flex flex-col p-4">
      <!-- BODY -->

      <div class="relative" #noteElement>
        @if (isEdit) {
          <textarea
            [rows]="1"
            class="!shadow-none p-0 w-full"
            style="height: 100px; padding: 12px"
            pInputTextarea
            [autoResize]="true"
            (focus)="onEdit()"
            (input)="refreshLayout.emit()"
            [(ngModel)]="noteValue"
            (paste)="onPasteText($event)"></textarea>
        } @else {
          <div>
            <app-raw-html-viewer [rawText]="noteValue"></app-raw-html-viewer>
          </div>

          <!-- @if (isLarge && !isEdit) {
            <span
              (click)="onToggleViewMore(); $event.stopPropagation()"
              class="text-blue-600 hover:text-blue-700 cursor-pointer"
              >{{ (isViewMore ? 'action.view-less' : 'action.view-more') | translate }}</span
            >
          } -->
        }
      </div>
    </div>

    <!-- COMMENTS -->
    @if (isEdit) {
      <div class="h-12 flex items-center justify-end px-3 gap-2 border-t border-neutral-alpha-200A">
        <app-button
          [label]="'action.cancel' | translate"
          variant="ghost-secondary"
          size="xs"
          (onClick)="onCancel()"></app-button>
        <app-button [label]="'action.save' | translate" size="xs" (onClick)="onUpdate()"></app-button>
      </div>
    } @else {
      <div
        [ngClass]="{ 'border-t border-neutral-alpha-200A': hasPermissionAddAppend || replyNotesValue.length > 0 }"
        (click)="$event.stopPropagation()">
        @if (replyNotesValue.length > 0) {
          <div class="flex flex-col gap-1.5 px-4 py-3">
            @for (reply of replyNotesValue; track reply.id; let i = $index) {
              @if (isEditAppend && editingAppendId === reply.id) {
                <div class="flex items-start gap-1.5 py-1.5">
                  <textarea
                    [(ngModel)]="appendNote"
                    class="w-full !shadow-none focus:border-blue-600"
                    style="height: 100px; padding: 12px"
                    pInputTextarea
                    [autoResize]="true"
                    [rows]="1"
                    [placeholder]="translatePrefix + 'enter-note' | translate"
                    (keydown.esc)="onCancelEditAppend()"
                    (paste)="onPasteText($event)">
                  </textarea>
                  <app-button
                    [label]="''"
                    variant="primary"
                    icon="icon-wl-send-alt"
                    size="md"
                    (onClick)="onEditAppend($event, i)"></app-button>
                </div>
              } @else {
                @if (!reply?.isDraft) {
                  <div class="flex flex-col gap-1.5 pb-1.5">
                    <div class="flex items-center justify-between gap-1.5">
                      <div class="flex flex-nowrap items-center whitespace-nowrap overflow-hidden">
                        <span class="text-2 font-semibold text-red-600 shrink-0">
                          Added by {{ reply?.createdBy?.fullName }}
                        </span>

                        <span
                          class="text-2 pl-1 flex-1 text-red-600 truncate"
                          pTooltip="{{ reply?.createdAt | date: 'MM/dd/yyyy HH:mm' }}"
                          tooltipPosition="top">
                          on {{ reply?.createdAt | date: 'MM/dd/yyyy HH:mm' }}
                        </span>
                      </div>

                      <div
                        *ngxPermissionsOnly="[
                          isCreatedByOwner(reply?.createdBy?.id) ? Permissions.NOTE_APPEND_EDIT : '',
                          isCreatedByOwner(reply?.createdBy?.id) ? Permissions.NOTE_APPEND_DELETE : '',
                          isCreatedIn30Minutes(reply?.createdBy?.id, reply.createdAt)
                            ? Permissions.NOTE_ADD_APPEND
                            : '',
                          Permissions.EDIT_ANY_NOTE,
                          Permissions.DELETE_ANY_NOTE
                        ]"
                        class="h-4 flex items-center justify-center rounded-sm cursor-pointer"
                        (click)="$event.stopPropagation(); appendMenu.toggle($event); onSelectReply(reply)">
                        <i class="icon-wl-dots-horizontal text-4"></i>

                        <p-menu #appendMenu appendTo="body" [model]="appendActions" [popup]="true">
                          <ng-template pTemplate="item" let-item>
                            <a
                              *ngxPermissionsOnly="[
                                isCreatedByOwner(reply?.createdBy?.id) ? item.permission : null,
                                (item.id === 'EDIT' || item.id === 'DELETE') &&
                                isCreatedIn30Minutes(reply.createdBy?.id, reply.createdAt)
                                  ? Permissions.NOTE_ADD_APPEND
                                  : null,
                                hasPermissionEditAnyNote ? item?.permissionEditAnyNote : null,
                                hasPermissionDeleteAnyNote ? item?.permissionDeleteAnyNote : null
                              ]"
                              pRipple
                              [ngClass]="item.styleClass"
                              class="flex items-center h-9 px-2 cursor-pointer">
                              <i [class]="item.icon + ' text-6'"></i>
                              <span class="ml-2 text-3">{{ 'action.' + item.label | translate }}</span>
                            </a>
                          </ng-template>
                        </p-menu>
                      </div>
                    </div>

                    <div class="">
                      <div class="whitespace-pre-line break-words">
                        <app-raw-html-viewer
                          [rawText]="
                            expandedReplies[reply.id] ? reply?.notes || '' : (reply?.notes | slice: 0 : 100) || ''
                          "></app-raw-html-viewer>
                        {{ !expandedReplies[reply.id] && (reply?.notes?.length ?? 0) > 100 ? '...' : '' }}
                      </div>
                      <!-- <span
                        class="text-blue-600 hover:text-blue-700 cursor-pointer"
                        *ngIf="(reply?.notes?.length ?? 0) > 100"
                        (click)="toggleReply(reply.id)">
                        {{ expandedReplies[reply.id] ? 'view less' : 'view more' }}
                      </span> -->
                    </div>
                  </div>
                }
              }
            }
          </div>
        }

        <div *ngxPermissionsOnly="Permissions.NOTE_ADD_APPEND">
          <div
            class="flex items-start gap-1.5 p-4"
            [ngClass]="{ 'border-t border-neutral-alpha-200A': replyNotesValue.length > 0 }">
            @if (isAddAppend) {
              <textarea
                [(ngModel)]="replyNote"
                class="w-full !shadow-none focus:border-blue-600"
                style="height: 200px"
                pInputTextarea
                [autoResize]="true"
                [rows]="1"
                [placeholder]="translatePrefix + 'enter-note' | translate"
                (keydown.esc)="onCancelAddAppend()"
                (paste)="onPasteText($event)">
              </textarea>
              <app-button
                [label]="''"
                variant="primary"
                icon="icon-wl-send-alt"
                size="md"
                (onClick)="onReply($event)"></app-button>
            } @else {
              @if (replyNoteByUser) {
                @if (isEditReplyDraft) {
                  <textarea
                    [(ngModel)]="replyNoteByUser.notes"
                    class="w-full !shadow-none focus:border-blue-600"
                    style="height: 100px"
                    pInputTextarea
                    [autoResize]="true"
                    [rows]="1"
                    [placeholder]="translatePrefix + 'enter-note' | translate"
                    (keydown.esc)="onEditReplyDraft()"
                    (paste)="onPasteText($event)">
                  </textarea>
                  <app-button
                    [label]="''"
                    variant="primary"
                    icon="icon-wl-send-alt"
                    size="md"
                    (onClick)="onEditAppendDraft($event)"></app-button>
                } @else {
                  <div class="flex items-center justify-between w-full gap-1">
                    <div class="flex items-center gap-1 cursor-pointer w-full max-w-[95%]" (click)="onEditReplyDraft()">
                      <span class="text-neutral-600 text-nowrap">Append: (Draft)</span>
                      <span class="text-neutral-600 truncate">{{ replyNoteByUser?.notes }}</span>
                    </div>
                    <i
                      class="text-4 text-red-600 icon-wl-delete z-50 cursor-pointer"
                      (click)="$event.stopPropagation(); onDelete(replyNoteByUser.id, 'APPEND')"></i>
                  </div>
                }
              } @else {
                <app-button
                  [label]="'Append'"
                  variant="ghost-primary"
                  icon="icon-wl-plus-circle"
                  size="xs"
                  (onClick)="onAddAppend()"></app-button>
              }
            }
          </div>
        </div>
      </div>
    }
  </div>
} @else {
  <!-- Draft -->
  <div class="border rounded-sm" [ngClass]="{ 'bg-neutral-100': !isEdit }">
    <!-- HEADER -->
    <div (click)="onEdit()">
      <div class="flex flex-col gap-1 h-auto pl-2 pr-2.5 border-b border-neutral-alpha-200A">
        <div class="flex items-center justify-between">
          @if (view !== 'COMPACT') {
            <div class="flex items-center justify-between gap-1.5">
              <div class="flex items-center pt-1">
                @if (isEdit) {
                  <div class="px-2">
                    <span class="font-semibold">Policy: </span>
                    <p-dropdown
                      appendTo="body"
                      [filter]="true"
                      [checkmark]="true"
                      [options]="policies"
                      optionValue="id"
                      optionLabel="number"
                      [placeholder]="'Select'"
                      [(ngModel)]="policyId"
                      styleClass="h-7 border-none !shadow-none"
                      dropdownIcon="icon-wl-arrow-drop-down"></p-dropdown>
                  </div>

                  <div [ngClass]="['flex items-center pl-2 pr-2.5 h-7']">
                    <span class="font-semibold">Note type: </span>
                    <app-note-status-dropdown
                      type="NOTE"
                      [totalOptions]="totalStatuses"
                      [disabled]="false"
                      [(visible)]="visible"
                      [(selected)]="statusId"
                      [initValue]="statusInit"
                      [options]="statuses"
                      [isLeadNoteGrid]="isLeadNoteGrid"
                      [isQuickAction]="isQuickAction"
                      [showIcon]="true"
                      [isApplyBtn]="false"
                      inputClass="h-7 border-none w-fit p-2">
                      <ng-template let-selected="selected">
                        <div *ngIf="!selected" class="placeholder">{{ 'Type note' }}</div>
                      </ng-template>
                    </app-note-status-dropdown>
                  </div>
                } @else {
                  <!-- Policy -->

                  <div class="w-fit flex items-center px-2 h-5 gap-1">
                    <span class="font-semibold">{{ overviewTranslatePrefix + 'policy' | translate }}: </span>
                    <span class="text-neutral-600 hover:underline">{{ note.policy?.number || '--' }} </span>
                  </div>
                }
              </div>
            </div>
          } @else {
            <!-- Policy -->
            @if (note.policy?.number && !isEdit) {
              <div class="w-fit flex items-center px-2 h-5 gap-1">
                <span class="font-semibold">{{ overviewTranslatePrefix + 'policy' | translate }}: </span>
                <span
                  pTooltip="{{ note.policy?.number }}"
                  class="text-neutral-600 hover:underline"
                  [ngClass]="isQuickAction ? 'max-w-[100px] truncate' : isLeadNoteGrid ? 'max-w-[150px] truncate' : ''"
                  >{{ note.policy?.number || '--' }}
                </span>
              </div>
            } @else if (!isEdit) {
              <!-- Note Type -->
              <div class="w-fit flex items-center px-2 gap-1">
                <span class="font-semibold">{{ overviewTranslatePrefix + 'note-type' | translate }}: </span>
                <span class="text-neutral-600 max-w-[100px] truncate" pTooltip="{{ note?.status?.name }}">
                  {{ note?.status?.name || '--' }}
                </span>
              </div>
            }
            @if (isEdit) {
              <div class="flex flex-col pt-1">
                <div class="px-2">
                  <span class="font-semibold">Policy: </span>
                  <p-dropdown
                    appendTo="body"
                    [filter]="true"
                    [checkmark]="true"
                    [options]="policies"
                    optionValue="id"
                    optionLabel="number"
                    [placeholder]="'Select'"
                    [(ngModel)]="policyId"
                    styleClass="h-7 border-none !shadow-none"
                    dropdownIcon="icon-wl-arrow-drop-down">
                    <ng-template let-policy pTemplate="selectedItem">
                      <div class="max-w-[175px]">
                        <div class="rounded-sm text-2 font-medium py-[2px] w-fit max-w-[150px] truncate">
                          {{ policy.number }}
                        </div>
                      </div>
                    </ng-template>
                  </p-dropdown>
                </div>

                <div [ngClass]="['flex items-center pl-2 pr-2.5 h-7']">
                  <span class="font-semibold">Note type: </span>
                  <app-note-status-dropdown
                    type="NOTE"
                    [totalOptions]="totalStatuses"
                    [disabled]="false"
                    [(visible)]="visible"
                    [(selected)]="statusId"
                    [initValue]="statusInit"
                    [options]="statuses"
                    [isLeadNoteGrid]="isLeadNoteGrid"
                    [isQuickAction]="isQuickAction"
                    [showIcon]="true"
                    [isApplyBtn]="false"
                    inputClass="h-7 border-none w-fit p-2">
                    <ng-template let-selected="selected">
                      <div *ngIf="!selected" class="placeholder">{{ 'Type note' }}</div>
                    </ng-template>
                  </app-note-status-dropdown>
                </div>
              </div>
            }
          }

          <!-- ICONS -->
          <div class="flex items-center">
            @if (view !== 'COMPACT' && !isEdit) {
              <!-- By -->
              <div class="w-fit flex items-center px-2 ml-2 h-5 gap-1">
                <span class="font-semibold">{{ overviewTranslatePrefix + 'by' | translate }}: </span>
                <span class="text-neutral-600">
                  {{ note?.createdBy?.fullName }}
                </span>
              </div>
            }
            <i
              class="text-4 text-red-600 icon-wl-delete z-50 cursor-pointer"
              (click)="$event.stopPropagation(); onDelete(note.id, 'NOTE')"></i>
          </div>
        </div>
        @if ((view !== 'COMPACT' || note.policy?.number) && !isEdit) {
          <!-- Note Type -->
          <div class="w-fit flex items-center px-2 gap-1">
            <span class="font-semibold">{{ overviewTranslatePrefix + 'note-type' | translate }}: </span>
            <span
              class="text-neutral-600"
              [ngClass]="
                isQuickAction
                  ? 'max-w-[100px] truncate'
                  : isLeadNoteGrid
                    ? 'max-w-[150px] truncate'
                    : isLatestNote
                      ? 'max-w-[380px] truncate'
                      : ''
              "
              pTooltip="{{ note?.status?.name }}">
              {{ note?.status?.name || '--' }}
            </span>
          </div>
        }
      </div>

      <div class="flex flex-col p-4">
        <!-- BODY -->

        <div class="relative">
          @if (isEdit) {
            <textarea
              [rows]="1"
              class="!shadow-none p-0 w-full"
              style="height: 100px; padding: 12px"
              pInputTextarea
              [autoResize]="true"
              (focus)="onEdit()"
              (input)="refreshLayout.emit()"
              [(ngModel)]="noteValue"
              (paste)="onPasteText($event)"></textarea>
          } @else {
            <div class="line-clamp-4 gap-1 flex text-neutral-600">
              <span class="">(Draft) </span>
              <app-raw-html-viewer [rawText]="noteValue"></app-raw-html-viewer>
            </div>
          }
        </div>
      </div>
    </div>
    @if (isEdit) {
      <div class="h-12 flex items-center justify-end px-3 gap-2 border-t border-neutral-alpha-200A">
        <app-button
          [label]="'action.cancel' | translate"
          variant="ghost-secondary"
          size="xs"
          (onClick)="onCancel()"></app-button>
        <app-button
          [label]="'action.save' | translate"
          size="xs"
          (onClick)="onUpdate()"
          [disabled]="!statusId"></app-button>
      </div>
    }
  </div>
}
